export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Roman.c31f99ef.eot";